import React from "react";

export const darkTheme = {
  bg: {
    base: "#0d1117",
    card: "rgba(22,27,42,0.9)",
    hover: "rgba(99,102,241,0.07)",
    input: "rgba(255,255,255,0.06)",
    sidebar: "#080c14",
  },
  border: {
    default: "rgba(99,102,241,0.13)",
    accent: "rgba(99,102,241,0.45)",
    focus: "rgba(99,102,241,0.7)",
  },
  text: {
    primary: "#f1f5f9",
    secondary: "#94a3b8",
    muted: "#475569",
    accent: "#818cf8",
  },
  accent: {
    gold: "#f59e0b",        // amber — revenue, money metrics
    goldLight: "#fbbf24",
    cyan: "#6366f1",        // indigo — active nav, primary links (replaces cyan)
    purple: "#a78bfa",      // violet — shops
    red: "#f87171",         // red — errors, danger
    green: "#10b981",       // emerald — success, online
  },
  font: {
    display: "'Plus Jakarta Sans', sans-serif",
    body: "'Inter', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  radius: { sm: 10, md: 14, lg: 18, xl: 24 },
};

export const lightTheme = {
  bg: {
    base: "#f0f4ff",
    card: "#ffffff",
    hover: "rgba(99,102,241,0.05)",
    input: "rgba(0,0,0,0.04)",
    sidebar: "#f8faff",
  },
  border: {
    default: "rgba(99,102,241,0.15)",
    accent: "rgba(99,102,241,0.5)",
    focus: "rgba(99,102,241,0.7)",
  },
  text: {
    primary: "#0f172a",
    secondary: "#475569",
    muted: "#94a3b8",
    accent: "#6366f1",
  },
  accent: {
    gold: "#d97706",
    goldLight: "#f59e0b",
    cyan: "#4f46e5",
    purple: "#7c3aed",
    red: "#dc2626",
    green: "#059669",
  },
  font: {
    display: "'Plus Jakarta Sans', sans-serif",
    body: "'Inter', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  radius: { sm: 10, md: 14, lg: 18, xl: 24 },
};

export const theme = lightTheme;

export const makeCard = (t: typeof darkTheme): React.CSSProperties => ({
  background: t.bg.card,
  border: `1px solid ${t.border.default}`,
  borderRadius: t.radius.lg,
  padding: "24px 28px",
});
